<template>
  <div class="">
    <div class="box2 is-margin-bottom-large">
      <div class="has-bg-white columns is-gapless is-vcentered">
        <div class="column is-padding-left">
          Facturation : <b>{{share.seller_name}}</b>
          <span v-if="share.company"> - Société : {{share.company_name}}</span>
        </div>
        <div class="column is-narrow is-border-left">
          <a @click="backToCommercialisation" class="button is-grey is-inverted is-square is-radiusless">
            <span class="icon is-size-4"><i class="far fa-times"></i></span>
          </a>
        </div>
      </div>
      <div class="is-padding-top-xsmall is-padding-right is-padding-bottom-xsmall is-padding-left"
          :class="hasAskFinish || errorAskFinish ? 'has-bg-danger' : 'has-bg-brand'"
          v-if="!currentIsInternal && !currentShare.terminated && isCurrencyEur">
        <div class="has-text-white is-size-6">
          <span class="icon is-small is-size-7"><i class="fas fa-exclamation-triangle"></i></span>
          <i v-if="!((errorAskFinish) && companyDataError)">Finaliser facture attribue un numéro de facture définitif / Attention, une facture finalisée n'est plus modifiable</i>
          <span v-else-if="errorAskFinish || errorAskFinish">
            <b>Finalisation facture impossible</b>
            <p class="is-italic" v-html="companyDataError"></p>
          </span>
        </div>
      </div>
      <div class="columns is-gapless" @click="clearInlineError" v-if="inlineError">
        <div class="column has-bg-danger is-padding-xsmall">
          <div class="has-text-white has-text-centered is-size-5">
            <i>{{inlineError.text}}</i>
            <span class="icon is-small is-pulled-right has-cursor-pointer"><i class="fas fa-times"></i></span>
          </div>
        </div>
      </div>
      <div v-if="share.total_rem_ht === 0" class="notification is-warning is-marginless is-min-height-50 is-flex">
        <div class="has-text-centered is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
          <span class="icon is-small has-text-danger"><i class="fas fa-exclamation-triangle"></i></span>
          Ce vendeur n'a pas de rémunération définie, vous ne pouvez pas éditer d'acompte ni de bonus en %
        </div>
      </div>
      <div class="is-border-top is-padding" v-if="!(!deposits.length && currentShare.terminated) && share.total_rem_ht !== 0 && sellerFacturation && sellerFacturation.is_external">
        <div class="has-text-grey is-size-7 is-margin-bottom-small is-uppercase">Acompte</div>
        <facturation-item v-for="(deposit, depositIdx) in deposits"
                          :key="deposit.uuid"
                          :item="deposit"
                          :parent="'deposits'"
                          :index="depositIdx"
                          :can-edit-bill="canDownloadBilll"
                          :bill-download-link="depositBillDownloadLinks[depositIdx]"
                          :is-terminated="currentShare.terminated"
                          :current-is-internal="currentIsInternal"
                          :company-data-error="companyDataError"
                          @askFinish="val => errorAskFinish = val"
                          @sendBill="sendDepositBill"
                          @delete="deleteItem"
                          @update="updateSellerShare"
                          @pendingEdit="val => pendingEditBill = val"
        ></facturation-item>
        <div class="field is-grouped is-margin-top-small" v-if="deposits && deposits.length < 2 && !currentShare.terminated">
          <div class="control">
            <a @click="newDeposit('percent')" class="button is-small is-light is-border is-rounded is-transform-none">&nbsp;
              <span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span>
              <span>Ajouter une ligne en %</span>
            </a>
          </div>
          <div class="control">
            <a @click="newDeposit('currency')" class="button is-small is-light is-border is-rounded is-transform-none">&nbsp;
              <span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span>
              <span>Ajouter une ligne en {{$currency}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="is-border-top is-border-bottom is-padding" v-if="!(!bonuses.length && currentShare.terminated)">
        <div class="has-text-grey is-size-7 is-margin-bottom-small is-uppercase">Bonus</div>
        <facturation-item v-for="(bonus, bonusIdx) in bonuses"
                          :key="bonus.uuid"
                          :item="bonus"
                          :parent="'bonuses'"
                          :index="bonusIdx"
                          :is-terminated="currentShare.terminated"
                          @delete="deleteItem"
                          @update="updateSellerShare"
        ></facturation-item>
        <div class="field is-grouped is-margin-top-small" v-if="bonuses && bonuses.length < 2 && !currentShare.terminated">
          <div class="control" v-if='share.remuneration !== 0'>
            <a @click="newBonus('percent')" class="button is-small is-light is-border is-rounded is-transform-none">&nbsp;
              <span class="icon is-small has-text-grey">
                <i class="fas fa-plus-square"></i>
              </span>
              <span>Ajouter une ligne en %</span>
            </a>
          </div>
          <div class="control">
            <a @click="newBonus('currency')" class="button is-small is-light is-border is-rounded is-transform-none">&nbsp;
              <span class="icon is-small has-text-grey">
                <i class="fas fa-plus-square"></i></span>
              <span>Ajouter une ligne en {{$currency}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-gapless is-padding has-bg-reserve has-text-white">
        <div class="column is-8 columns is-multiline is-gapless">
          <div class="column is-6">Honoraires vendeur ({{currentShare.remuneration}}%)</div>
          <div class="column is-6 has-text-right">{{currentShare.total_rem_ht.toFixed(2)}} {{$currency}} HT</div>
          <div class="column is-6">Acompte</div>
          <div class="column is-6 has-text-right">{{currentShare.total_deposit_ht.toFixed(2)}} {{$currency}} HT</div>
          <div class="column is-6">Bonus</div>
          <div class="column is-6 has-text-right">{{currentShare.total_bonus_ht.toFixed(2)}} {{$currency}} HT</div>
        </div>
      </div>
      <div class="columns is-gapless is-padding">
        <div class="column is-8 columns is-multiline is-gapless">
          <div class="column is-6"><b class="is-uppercase">Solde HT :</b></div>
          <div class="column has-text-weight-bold is-6 has-text-right">{{currentShare.total_balance_ht.toFixed(2)}} {{$currency}} HT</div>
          <div class="column is-6"><span class="is-uppercase">TVA : <span class="is-lowercase">{{addTva ? '' : 'non applicable'}}</span></span></div>
          <div class="column is-6 has-text-right">{{(currentShare.total_balance_ttc - currentShare.total_balance_ht).toFixed(2)}} {{$currency}}</div>
          <div class="column is-6"><b class="is-uppercase">Solde TTC :</b></div>
          <div class="column is-6 has-text-weight-bold has-text-right">{{currentShare.total_balance_ttc.toFixed(2)}} {{$currency}} TTC</div>
        </div>
        <div class="column is-narrow is-padding-left">
          <div class="field" v-if="currentShare.company && !cantEditTva && !currentShare.terminated && !pendingEditBill">
            <input :id="`tva_applicable-${currentShare.seller}`" :name="`tva_applicable-${currentShare.seller}`"
                   class="switch is-rounded is-success"
                   type="checkbox" v-model="addTva" @input="updateTva(addTva)">
            <label :for="`tva_applicable-${currentShare.seller}`" class="is-size-6">
              TVA {{addTva ? '' : 'non'}} applicable
            </label>
          </div>
          <div class="field is-grouped" v-if="!hasAskFinish && !pendingEditBill && isCurrencyEur">
            <div v-if="currentShare.company" class="control" :data-tooltip="smallErrors"
                 :class="{'tooltip is-tooltip-top is-tooltip-danger':companyDataError !== null}">
              <a @click="balanceBillDownload(currentShare.seller)"
                 :disabled="companyDataError" :class="{'disabled': companyDataError}"
                 class="button is-small is-white is-border is-circle">
                <span class="icon is-small">
                  <i class="fas fa-file-pdf is-size-5"></i>
                </span>
              </a>
            </div>
            <div class="control" v-if="!currentShare.terminated && !currentIsInternal && isCurrencyEur">
              <a @click="askFinish" class="button is-small is-success is-rounded is-transform-none">
                <span class="is-small"><i class="fas fa-lock-alt is-size-5"></i></span>
                <span class="has-text-weight-bold is-padding-left-xsmall">Finaliser facture*</span>
              </a>
            </div>
            <div class="control" v-if="currentShare.terminated && !currentShare.balance_billing_date">
              <a @click="sendBill" class="button is-small is-white is-rounded is-transform-none is-border">
                <span class="is-small"><i class="fas fa-check is-size-5"></i></span>
                <span class="has-text-weight-bold is-padding-left-xsmall">Valider envoi</span>
              </a>
            </div>
            <div class="control" v-if="currentShare.balance_billing_date">
              <div class="tag is-medium is-success is-radius-large">
                <span class="icon is-small is-size-6"><i class="fas fa-envelope"></i></span><span class="is-size-6">Envoyé le {{currentShare.balance_billing_date | date}}</span>
              </div>
            </div>
          </div>
          <div class="field is-grouped" v-else-if="!pendingEditBill && isCurrencyEur">
            <div class="control">
              <a @click="confirmFinish" class="button is-small is-danger is-rounded">
                <span>Confirmer finalisation</span>
              </a>
            </div>
            <div class="control">
              <a @click="cancelAsk" class="button is-small is-white is-border is-circle ">
                <span class="icon is-small">
                  <i class="fas fa-times is-size-5"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
  import FacturationItem from './FacturationItem'
  import { isNil, isEmpty, uniq } from 'lodash'
  import { mapGetters } from 'vuex'
  import { AdvMx, Error } from '@/mixins'
  import moment from 'moment'

  const emptyDeposit = {
    unit: null,
    amount: 0,
    total_ht: 0,
    total_ttc: 0,
    sending_date: null
  }
  const emptyBonus = {
    unit: null,
    amount: 0,
    total_ht: 0,
    total_ttc: 0
  }

  export default {
    name: 'Facturation',
    components: {FacturationItem},
    mixins: [AdvMx, Error],
    data () {
      return {
        company: false,
        displayBonuses: false,
        displayDeposits: false,
        saveShare: false,
        hasAskFinish: false,
        errorAskFinish: false,
        addTva: true,
        pendingEditBill: false,
        displayInlineError: true,
        smallErrors: [],
        sellerFacturation: null
      }
    },
    props: {
      share: {
        type: Object,
        required: true
      }
    },
    watch: {
      'share' (v) {
        this.init()
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager']),
      isCurrencyEur () {
        if (!this.$configs) return
        return this.$configs.CURRENCY === 'EUR'
      },
      isCountryFra () {
        if (!this.$configs) return
        return this.$configs.COUNTRY === 'FRA'
      },
      companyDataError () {
        let errors = []
        this.smallErrors = []
        if (isNil(this.company)) {
          errors.push('- Aucune société liée à cette vente')
          this.smallErrors.push('- Aucune société liée à cette vente')
        }
        let company = this.company
        if (company && !isEmpty(company)) {
          let companyEditLink = `<a class="has-text-white" href="/#/societes/${company.pk}/edition?check=1">(Éditer la société)</a>`
          if (!company.tva_intra || company.tva_intra.length === 0) {
            errors.push(`- Numero de TVA intracommunautaire manquant ${companyEditLink}`)
            this.smallErrors.push('- Numero de TVA intracommunautaire manquant')
          }
          if (!company.siren || company.siren.length === 0) {
            errors.push(`- Numero de SIREN manquant ${companyEditLink}`)
            this.smallErrors.push('- Numero de SIREN manquant')
          }
          if (!company.siret || company.siret.length === 0) {
            errors.push(`- Numero de SIRET manquant ${companyEditLink}`)
            this.smallErrors.push('- Numero de SIRET manquant')
          }
          let address = company.address
          if (isNil(address)) {
            errors.push(`- Adresse postale incomplète ${companyEditLink}`)
            this.smallErrors.push('- Adresse postale incomplète')
          }
          if (address) {
            if (!address.city || address.city.length === 0) {
              errors.push(`- Adresse postale incomplète ${companyEditLink}`)
              this.smallErrors.push('- Adresse postale incomplète')
            }
            if (!address.zip_code || address.zip_code.length === 0) {
              errors.push(`- Adresse postale incomplète ${companyEditLink}`)
              this.smallErrors.push('- Adresse postale incomplète')
            }
          }
          if (!company.person_in_charge_email || company.person_in_charge_email.length === 0) {
            errors.push(`- Mail du responsable société manquant ${companyEditLink}`)
            this.smallErrors.push('- Mail du responsable société manquant')
          }
          if (!company.person_in_charge_phone || company.person_in_charge_phone.length === 0) {
            errors.push(`- Téléphone du responsable société manquant ${companyEditLink}`)
            this.smallErrors.push('- Téléphone du responsable société manquant')
          }
        }
        if (!this.program.ref || this.program.ref.length < 4) {
          let programEditLink = `<a class="has-text-white" href="/#/programmes/${this.program.pk}/edition?check=1">(Éditer le programme)</a>`
          errors.push(`- Réference du programme non valide (minimum de quatre caractères) ${programEditLink}`)
          this.smallErrors.push('- Réference du programme non valide (minimum de quatre caractères)')
        }
        if (errors.length) {
          this.smallErrors = uniq(this.smallErrors).join('\n')
          return uniq(errors).join('<br>')
        } else return null
      },
      companyPk () {
        return this.currentShare.company
      },
      canDownloadBilll () {
        return this.companyDataError === null
      },
      advPk () {
        return this.$route.params.id
      },
      sellerPk () {
        return this.currentShare.seller
      },
      depositBillDownloadLinks () {
        const APIROOT = this.$configs.APIROOT
        return this.currentShare.deposits.map((x, i) => {
          return `${APIROOT}/facture-adv/${this.advPk}/share/${this.sellerPk}?deposit=${i}`
        })
      },
      balanceBillDownloadLink () {
        const APIROOT = this.$configs.APIROOT
        return `${APIROOT}/facture-adv/${this.advPk}/share/${this.sellerPk}`
      },
      cantEditTva () {
        if (this.currentShare) {
          let deposits = this.currentShare.deposits.reduce((a, b) => {
            return b.terminated ? a + 1 : a
          }, 0)
          let bonuses = this.currentShare.bonuses.reduce((a, b) => {
            return b.terminated ? a + 1 : a
          }, 0)
          return deposits + bonuses > 0
        }
      },
      deposits () {
        return this.currentShare.deposits
      },
      bonuses () {
        return this.currentShare.bonuses
      },
      currentShare () {
        if (this.share) {
          this.addTva = this.share.add_tva
          return Object.assign({}, this.share)
        } else {}
      },
      currentIsInternal () {
        return isNil(this.share.company)
      }
    },
    methods: {
      balanceBillDownload (seller) {
        let params = {
          linkEmbed: this.balanceBillDownloadLink,
          facture: true
        }
        // if (this.companyDataError) return
        // const sellerName = slugify(this.share.seller_name)
        // const filename = `facture-${this.adv.ref}-${sellerName}.pdf`
        // downloadURI(this.balanceBillDownloadLink, filename)
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
      },
      getCompany () {
        console.log('getCompany')
        this.$api.companyService.getOne(this.companyPk).then(res => {
          this.company = res.data
        })
      },
      sendDepositBill ({item, index, full}) {
        if (item && !isNil(index)) {
          item.sending_date = moment().toDate()
          this.currentShare.deposits[index] = item
        } else if (full) {
          this.currentShare.sending_date = moment().toDate()
        }
        this.saveShare = true
        if (this.currentShare.balance_billing_date) delete this.currentShare.balance_billing_date
        this.$api.advService.patchShare(this.advPk, this.currentShare.seller, this.currentShare).then(r => {
          console.log('patched advShare > ', r.data)
          this.saveShare = false
          this.editAdv(false)
          this.updateCom()
        }).catch(err => {
          this.handleError(err)
        })
      },
      sendBill () {
        let edit = {balance_billing_date: moment().toDate()}
        this.saveShare = true
        this.$api.advService.patchShare(this.advPk, this.currentShare.seller, edit).then(r => {
          console.log('patched advShare > ', r.data)
          this.saveShare = false
          this.editAdv(false)
          this.updateCom()
        }).catch(err => {
          this.handleError(err)
        })
      },
      backToCommercialisation () {
        this.$emit('backToInitialShares')
        this.$emit('changePanel', {panel: 'COMMERCIALISATION', seller: null})
      },
      newDeposit (unit) {
        let data = Object.assign({}, emptyDeposit, {unit})
        this.currentShare.deposits.push(data)
      },
      newBonus (unit) {
        let data = Object.assign({}, emptyBonus, {unit})
        this.currentShare.bonuses.push(data)
      },
      deleteItem ({index, parent}) {
        this.currentShare[parent].splice(index, 1)
        this.updateSellerShare({})
      },
      askFinish () {
        if (this.companyDataError) {
          this.errorAskFinish = true
          return
        }
        this.hasAskFinish = true
      },
      cancelAsk () {
        this.hasAskFinish = false
      },
      confirmFinish () {
        this.currentShare.terminated = true
        this.hasAskFinish = false
        this.updateSellerShare({})
      },
      updateTva (tva) {
        this.currentShare.add_tva = !tva
        this.updateSellerShare({})
      },
      updateSellerShare ({parent, index, item}) {
        if (parent && index && item) {
          this.currentShare[parent][index] = item
        }
        this.saveShare = true
        this.$api.advService.putShare(this.advPk, this.currentShare.seller, this.currentShare).then(r => {
          this.saveShare = false
          this.editAdv(false)
          console.log('updated advShare > ', r.data)
          this.$emit('updateCurrentShare', r.data)
          this.updateCom()
        }).catch(err => {
          this.handleError(err)
        })
      },
      init () {
        if (this.currentShare.deposits && this.currentShare.deposits.length) {
          this.displayDeposits = true
        }
        if (this.currentShare.bonuses && this.currentShare.bonuses.length) {
          this.displayBonuses = true
        }
      },
      getSeller () {
        this.$api.userService.getOne(this.sellerPk).then(res => {
          this.sellerFacturation = res.data
        }).catch(err => {
          console.log(err)
        })
      }
    },
    created () {
      this.init()
      if (this.currentShare.company) {
        this.getCompany()
      }
      this.getSeller()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Commercialisation/Facturation.vue